import { makeStyles } from "tss-react/mui";

export const useFeatureCardStyles = makeStyles()(() => ({
  root:{
    height: "78.26%",
    display:"flex",
    flex: 1,
    flexDirection:"column",
    justifyContent:"center",
    alignItems:"center",
    gap: 8,
    borderRadius: "1.25rem",
    padding: "1.5rem",
    border: "1px solid var(--color-blue-500)",
    background: "var(--bg-white)",
    boxShadow: "0px 4px 20px 0px rgba(88, 113, 159, 0.10)",
    "&:hover":{
      background: "var(--color-blue-50)"
    },
    "@media(min-width: 1536px)": {
      height: "79.59%",
    },
    "@media(min-width: 1920px)": {
      height: "79.59%",
    }
  },
  container:{
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "1rem",
    alignSelf: "stretch",
  },
  badgesection:{
    display:"flex",
    flexDirection:"row",
    justifyContent:"flex-start",
    height: "1.5rem",
  },
  title:{
    fontWeight: 500,
    fontSize: "1.5rem",
    lineHeight: "100%",
    letterSpacing: "-1%",
    color: "var(--color-neutral-800)"
  },
  actions:{
    display:"flex",
    flexDirection: "column",
    justifyItems:"flex-end",
    alignSelf:"stretch",
   
  },
  externalLink:{
    height: "2rem",
    alignSelf: "flex-end"
  },
  externalLinkIcon:{
    height: "2rem",
    width:"2rem",
    fill:"var(--color-blue-500)"
  },
  badge: {
    height: "1.5rem",
    gap: "0.75rem",
    borderRadius: "0.25rem",
    padding: "0.375rem",
    border: 0,
    fontSize: "0.75rem",
    fontWeight: 400,
    lineHeight: "115%",
  }
}));
